import React from "react";

export default function LocalBusinessSchema() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "HomeAndConstructionBusiness",
    "name": "Top-Notch Contractors",
    "url": "https://topnotch-contractors.com",
    "telephone": "+14105989933",
    "email": "contact@topnotch-contractors.com",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Dundalk",
      "addressRegion": "MD",
      "addressCountry": "US"
    },
    "areaServed": [
      "Baltimore, MD", "Dundalk, MD", "Essex, MD", "Towson, MD",
      "Catonsville, MD", "Parkville, MD", "Owings Mills, MD",
      "Middle River, MD", "Rosedale, MD", "Perry Hall, MD"
    ],
    "openingHours": "Mo-Fr 07:00-17:00",
    "description": "Baltimore's trusted remodeling contractor since 2010. Kitchen, bathroom, basement, and whole-house renovations. MHIC# 05-147079. Licensed & Insured.",
    "slogan": "Baltimore's Trusted Remodeling Contractor Since 2010",
    "foundingDate": "2010",
    "numberOfEmployees": { "@type": "QuantitativeValue", "value": 7 },
    "license": "MHIC# 05-147079",
    "sameAs": [
      "https://www.facebook.com/TopNotchContractors/",
      "https://www.instagram.com/topnotchcontractors/",
      "https://www.google.com/maps/place/Top-Notch+Contractors"
    ]
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}